'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PropTypes = require('prop-types');
var React = require('react');
var createReactClass = require('create-react-class');
var _ = require('lodash');

var LocalizationMixin = require('../../../localization/CommonLocalizationMixin');
var ADAHelpers = require('../../../lib/ADAHelpers');
var StringHelper = require('../../../lib/StringHelper');

var YourNextRewardCard = require('../../loyalty/yourNextRewardCard.js');
var ChooseNextRewardComponent = require('../../loyalty/chooseNextRewardComponent.js');
var PageTitle = require('../../pageTitle.js').default;

var SignUpStatus = {
    NEW_ENROLLMENT_SOCIAL_SIGN_UP_NO_POSTAL: "NEW_ENROLLMENT_SOCIAL_SIGN_UP_NO_POSTAL",
    NEW_ENROLLMENT_R_UNAVAILABLE: "NEW_MEMBER_R_UNAVAILABLE",
    NEW_ENROLLMENT_R_AVAILABLE: "NEW_MEMBER_R_AVAILABLE",
    EXISTING_NOT_ENROLLED_NO_POSTAL: "EXISTING_NOT_ENROLLED_POSTAL_NOT_VALIDATED",
    EXISTING_NOT_ENROLLED_R_UNAVAILABLE: "EXISTING_NOT_ENROLLED_R_UNAVAILABLE",
    EXISTING_NOT_ENROLLED_R_AVAILABLE: "EXISTING_NOT_ENROLLED_R_AVAILABLE"
};

var FieldNames = {
    POSTAL: "POSTAL",
    PHONE: "PHONE",
    LOYALTY_CARD_TOGGLE: "LOYALTY_CARD_TOGGLE",
    LOYALTY_CARD_NO: "LOYALTY_CARD_NO",
    CHOOSE_REWARD: "CHOOSE_REWARD",
    COMING_SOON: "COMING_SOON",
    WENDYMAIL_TOGGLE: "WENDYMAIL_TOGGLE",
    TERMS_CONDITIONS_TOGGLE: "TERMS_CONDITIONS_TOGGLE",
    CTA_BUTTON: "CTA_BUTTON",
    SKIP_LOYALTY: "SKIP_LOYALTY",
    NOT_NOW: "NOT_NOW"
};

var LoginLoyaltyStepTwo = createReactClass({
    displayName: 'LoginLoyaltyStepTwo',
    mixins: [LocalizationMixin],

    propTypes: {
        user: PropTypes.object,
        removeErrorClick: PropTypes.func.isRequired,
        handleValidatePostalCode: PropTypes.func.isRequired,
        loyaltyAvailable: PropTypes.bool.isRequired,
        postalCode: PropTypes.string,
        postalCodeValidated: PropTypes.bool.isRequired,
        showPostalLoading: PropTypes.bool.isRequired,
        handleJoinRewardsClick: PropTypes.func.isRequired,
        handleSkipRewardsClick: PropTypes.func.isRequired,
        handleFinishRewardsClick: PropTypes.func.isRequired,
        setSelectedReward: PropTypes.func.isRequired,
        rewardOptions: PropTypes.array.isRequired
    },

    getInitialState: function getInitialState() {

        return {
            isExistingUser: this.props.isExistingUser,
            loyaltyAvailable: this.props.loyaltyAvailable,
            postalCode: this.props.postalCode,
            phoneNumber: '',
            loyaltyCardNumber: '',
            postalCodeValidated: false,
            showPostalLoading: false,
            selectedReward: null,
            signUpStatus: this.getCurrentSignupStatus(this.props.isExistingUser, this.props.loyaltyAvailable, false),
            termsConditionsOptIn: false,
            wendyMailOptIn: false,
            hasLoyaltyCard: false,
            PAGE_TO_DISPLAY: "SUMMARY"
        };
    },

    componentDidMount: function componentDidMount() {
        if (this.state.postalCode && this.state.isExistingUser) {
            this.validatePostal(this.state.postalCode);
        }
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var postalCode = this.state.postalCode;
        if (!postalCode || postalCode.length === 0) {
            postalCode = nextProps.postalCode;
            this.validatePostal(postalCode);
        }
        this.setState({
            postalCode: postalCode,
            loyaltyAvailable: nextProps.loyaltyAvailable,
            postalCodeValidated: nextProps.postalCodeValidated,
            showPostalLoading: nextProps.showPostalLoading
        });
    },

    showChooseNextReward: function showChooseNextReward(pageToDisplay) {
        return pageToDisplay === "CHOOSE_REWARD";
    },

    showSignupSummary: function showSignupSummary(pageToDisplay) {
        return pageToDisplay === "SUMMARY";
    },

    spliceError: function spliceError(idx) {
        if (this.props.removeErrorClick) {
            this.props.removeErrorClick(idx);
        }
    },

    render: function render() {
        var _this = this;

        var config = require('../../../lib/config').loyaltyConfig;

        var phoneValidated = !!this.state.phoneNumber;
        var loyaltyCardValidated = this.state.hasLoyaltyCard ? !!this.state.loyaltyCardNumber : true;
        var rewardSelected = !!this.state.selectedReward;

        var pageTitleText = this.getLocalizedText('rewards_join_title');
        var signUpStatus = this.getCurrentSignupStatus(this.state.isExistingUser, this.state.loyaltyAvailable, this.state.postalCodeValidated);
        var validatedRequiredFields = this.validateRequiredFields(signUpStatus, phoneValidated, loyaltyCardValidated, this.state.termsConditionsOptIn, rewardSelected);
        var includedFields = this.getIncludedFields(config, signUpStatus, this.state.hasLoyaltyCard);

        var errors = this.props.errors && this.props.errors.length > 0 ? React.createElement(
            'div',
            { ref: 'errorAlert', className: 'row' },
            React.createElement(
                'div',
                { className: 'col-xs-12 errors' },
                this.props.errors.map(function (error, idx) {
                    return React.createElement(
                        'div',
                        null,
                        React.createElement(
                            'p',
                            { className: 'bg-danger' },
                            error,
                            React.createElement(
                                'span',
                                { onClick: _this.spliceError.bind(_this, idx), className: 'clear-error', 'aria-hidden': 'true' },
                                '\xD7'
                            )
                        )
                    );
                })
            )
        ) : [];

        return React.createElement(
            'div',
            null,
            this.showChooseNextReward(this.state.PAGE_TO_DISPLAY) && React.createElement(BackButton, { handleClick: this.cancelChooseNextReward }),
            React.createElement(
                'div',
                { className: 'loyalty-sign-up-wrapper container' },
                this.showChooseNextReward(this.state.PAGE_TO_DISPLAY) && React.createElement(ChooseNextRewardWrapper, {
                    lang: this.props.lang, cntry: this.props.cntry,
                    cancelChooseNextReward: this.cancelChooseNextReward,
                    rewardOptions: this.props.rewardOptions,
                    currentTotalPoints: 0,
                    setSelectedReward: this.setSelectedReward,
                    selectedReward: this.state.selectedReward }),
                this.showSignupSummary(this.state.PAGE_TO_DISPLAY) && React.createElement(
                    'div',
                    { className: 'loyalty-sign-up col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2' },
                    React.createElement(
                        'div',
                        { className: 'row' },
                        React.createElement(PageTitle, { titleText: pageTitleText })
                    ),
                    React.createElement(
                        'div',
                        { 'aria-live': 'polite' },
                        errors
                    ),
                    React.createElement(
                        'div',
                        { className: 'content-wrapper' },
                        React.createElement(
                            'div',
                            { className: 'content-container card row' },
                            React.createElement(HeroImageComponent, {
                                lang: this.props.lang,
                                cntry: this.props.cntry,
                                includedFields: includedFields }),
                            React.createElement(
                                'div',
                                { className: 'loyalty-sign-up-container' },
                                _.includes(includedFields, FieldNames.POSTAL) && React.createElement(PostalCodeInputComponent, {
                                    lang: this.props.lang,
                                    cntry: this.props.cntry,
                                    postalCode: this.state.postalCode,
                                    handlePostalChange: this.handlePostalChange,
                                    loyaltyAvailable: this.state.loyaltyAvailable,
                                    showPostalLoading: this.state.showPostalLoading }),
                                _.includes(includedFields, FieldNames.LOYALTY_CARD_TOGGLE) && React.createElement(LoyaltyCardNumberToggleComponent, {
                                    hasLoyaltyCard: this.state.hasLoyaltyCard,
                                    toggleLoyaltyCard: this.toggleLoyaltyCard }),
                                _.includes(includedFields, FieldNames.LOYALTY_CARD_NO) && React.createElement(LoyaltyCardNumberInputComponent, {
                                    lang: this.props.lang,
                                    cntry: this.props.cntry,
                                    hasLoyaltyCard: this.state.hasLoyaltyCard,
                                    toggleLoyaltyCard: this.toggleLoyaltyCard,
                                    loyaltyCardNumber: this.state.loyaltyCardNumber,
                                    handleLoyaltyCardNumberChange: this.handleLoyaltyCardNumberChange }),
                                _.includes(includedFields, FieldNames.PHONE) && React.createElement(PhoneNumberInputComponent, {
                                    lang: this.props.lang,
                                    cntry: this.props.cntry,
                                    phoneNumber: this.state.phoneNumber,
                                    handlePhoneNumberChange: this.handlePhoneNumberChange }),
                                _.includes(includedFields, FieldNames.CHOOSE_REWARD) && React.createElement(ChooseRewardComponent, {
                                    lang: this.props.lang,
                                    cntry: this.props.cntry,
                                    selectedReward: this.state.selectedReward,
                                    handleChooseRewardClick: this.handleChooseRewardClick }),
                                _.includes(includedFields, FieldNames.COMING_SOON) && React.createElement(ComingSoonComponent, {
                                    lang: this.props.lang,
                                    cntry: this.props.cntry }),
                                _.includes(includedFields, FieldNames.WENDYMAIL_TOGGLE) && React.createElement(ToggleWendyMailComponent, {
                                    lang: this.props.lang,
                                    cntry: this.props.cntry,
                                    toggleWendyMail: this.toggleWendyMail,
                                    wendyMailOptIn: this.state.wendyMailOptIn }),
                                _.includes(includedFields, FieldNames.TERMS_CONDITIONS_TOGGLE) && React.createElement(TermsAndConditionsComponent, {
                                    lang: this.props.lang,
                                    cntry: this.props.cntry,
                                    termsConditionsOptIn: this.state.termsConditionsOptIn,
                                    toggleTermsConditions: this.toggleTermsConditions }),
                                _.includes(includedFields, FieldNames.CTA_BUTTON) && this.buildCTAButton(signUpStatus, validatedRequiredFields),
                                _.includes(includedFields, FieldNames.SKIP_LOYALTY) && React.createElement(SkipLoyaltyComponent, _extends({}, this.props, { includedFields: includedFields,
                                    handleSkipRewardsClick: this.props.handleSkipRewardsClick })),
                                _.includes(includedFields, FieldNames.NOT_NOW) && React.createElement(NotNowLoyaltyButton, { includedFields: includedFields,
                                    handleNotNowClick: this.props.handleNotNowClick })
                            )
                        )
                    )
                )
            )
        );
    },

    getCurrentSignupStatus: function getCurrentSignupStatus(isExistingUser, hasLoyaltyAvailable, postalCodeValidated) {
        if (isExistingUser) {
            if (!postalCodeValidated) {
                return SignUpStatus.EXISTING_NOT_ENROLLED_NO_POSTAL;
            } else if (postalCodeValidated && !hasLoyaltyAvailable) {
                return SignUpStatus.EXISTING_NOT_ENROLLED_R_UNAVAILABLE;
            } else if (postalCodeValidated && hasLoyaltyAvailable) {
                return SignUpStatus.EXISTING_NOT_ENROLLED_R_AVAILABLE;
            }
        } else {
            if (!hasLoyaltyAvailable) {
                return SignUpStatus.NEW_ENROLLMENT_R_UNAVAILABLE;
            } else {
                return SignUpStatus.NEW_ENROLLMENT_R_AVAILABLE;
            }
        }
    },

    getIncludedFields: function getIncludedFields(config, signUpStatus, hasLoyaltyCard) {
        var includedFields = [];
        if (signUpStatus === SignUpStatus.NEW_ENROLLMENT_R_UNAVAILABLE) {
            includedFields = [FieldNames.COMING_SOON, FieldNames.WENDYMAIL_TOGGLE, FieldNames.CTA_BUTTON];
        } else if (signUpStatus === SignUpStatus.NEW_ENROLLMENT_R_AVAILABLE) {
            includedFields = [FieldNames.PHONE, FieldNames.CHOOSE_REWARD, FieldNames.TERMS_CONDITIONS_TOGGLE, FieldNames.SKIP_LOYALTY, FieldNames.CTA_BUTTON];

            if (config.enableLoyaltyCard) {
                includedFields.push(FieldNames.LOYALTY_CARD_TOGGLE);

                if (hasLoyaltyCard) {
                    includedFields.push(FieldNames.LOYALTY_CARD_NO);
                }
            }
        } else if (signUpStatus === SignUpStatus.EXISTING_NOT_ENROLLED_NO_POSTAL) {
            includedFields = [FieldNames.POSTAL];
        } else if (signUpStatus === SignUpStatus.EXISTING_NOT_ENROLLED_R_UNAVAILABLE) {
            includedFields = [FieldNames.POSTAL, FieldNames.COMING_SOON, FieldNames.WENDYMAIL_TOGGLE, FieldNames.CTA_BUTTON];
        } else if (signUpStatus === SignUpStatus.EXISTING_NOT_ENROLLED_R_AVAILABLE) {
            includedFields = [FieldNames.POSTAL, FieldNames.PHONE, FieldNames.CHOOSE_REWARD, FieldNames.TERMS_CONDITIONS_TOGGLE, FieldNames.NOT_NOW, FieldNames.CTA_BUTTON];

            if (config.enableLoyaltyCard) {
                includedFields.push(FieldNames.LOYALTY_CARD_TOGGLE);

                if (hasLoyaltyCard) {
                    includedFields.push(FieldNames.LOYALTY_CARD_NO);
                }
            }
        }

        return includedFields;
    },

    validateRequiredFields: function validateRequiredFields(signUpStatus, phoneValidated, loyaltyCardValidated, termsOptIn, rewardSelected) {
        if (signUpStatus === SignUpStatus.NEW_ENROLLMENT_R_UNAVAILABLE) {
            return true;
        } else if (signUpStatus === SignUpStatus.NEW_ENROLLMENT_R_AVAILABLE && phoneValidated && loyaltyCardValidated && termsOptIn && rewardSelected) {
            return true;
        } else if (signUpStatus === SignUpStatus.EXISTING_NOT_ENROLLED_R_UNAVAILABLE) {
            return true;
        } else if (signUpStatus === SignUpStatus.EXISTING_NOT_ENROLLED_R_AVAILABLE && phoneValidated && loyaltyCardValidated && termsOptIn && rewardSelected) {
            return true;
        }

        return false;
    },

    handleChooseRewardClick: function handleChooseRewardClick() {
        this.setState({ PAGE_TO_DISPLAY: "CHOOSE_REWARD" }, function () {
            return window.document.body.scrollTop = 0;
        });
    },

    cancelChooseNextReward: function cancelChooseNextReward() {
        this.setState({ PAGE_TO_DISPLAY: "SUMMARY" }, function () {
            return window.document.body.scrollTop = 0;
        });
    },

    setSelectedReward: function setSelectedReward(selectedReward) {
        var setStateCallback = function setStateCallback() {
            window.document.body.scrollTop = 0;
            var elementToFocus = document.getElementById('item-and-change');
            if (elementToFocus) {
                elementToFocus.focus();
            }
            this.props.setSelectedReward(selectedReward);
        };

        this.setState({ PAGE_TO_DISPLAY: "SUMMARY", selectedReward: selectedReward }, setStateCallback);
    },

    onCTAButtonClick: function onCTAButtonClick() {
        var loyaltyCardNum = this.state.hasLoyaltyCard ? this.state.loyaltyCardNumber : '';

        var signupStatus = this.getCurrentSignupStatus(this.state.isExistingUser, this.state.loyaltyAvailable, this.state.postalCodeValidated);
        if (signupStatus === SignUpStatus.NEW_ENROLLMENT_R_AVAILABLE || signupStatus === SignUpStatus.EXISTING_NOT_ENROLLED_R_AVAILABLE) {
            this.props.handleJoinRewardsClick(this.state.postalCode, this.state.phoneNumber, this.state.selectedReward.rewardId, loyaltyCardNum);
        } else if (signupStatus === SignUpStatus.NEW_ENROLLMENT_R_UNAVAILABLE || signupStatus === SignUpStatus.EXISTING_NOT_ENROLLED_R_UNAVAILABLE) {
            this.props.handleFinishRewardsClick(this.state.wendyMailOptIn, this.state.postalCode);
        }
    },

    buildCTAButton: function buildCTAButton(signUpStatus, enabled) {
        return React.createElement(LoyaltyCTAButton, {
            lang: this.props.lang,
            cntry: this.props.cntry,
            enabled: enabled,
            buttonText: this.getCTAButtonText(signUpStatus),
            clickHandler: this.onCTAButtonClick });
    },

    getCTAButtonText: function getCTAButtonText(signUpStatus) {
        if (signUpStatus === SignUpStatus.NEW_ENROLLMENT_R_AVAILABLE || signUpStatus === SignUpStatus.EXISTING_NOT_ENROLLED_R_AVAILABLE) {
            return this.getLocalizedText('rewards_join_button');
        } else if (signUpStatus === SignUpStatus.EXISTING_NOT_ENROLLED_R_UNAVAILABLE) {
            return this.getLocalizedText('rewards_done_button');
        } else if (signUpStatus === SignUpStatus.NEW_ENROLLMENT_R_UNAVAILABLE) {
            return this.getLocalizedText('rewards_next_button');
        }
    },

    validatePostal: _.debounce(function (input) {
        if (!input) return;

        this.props.handleValidatePostalCode(input);
    }, 1000),

    handlePostalChange: function handlePostalChange(e) {
        if (e.target.value.length <= 7) {
            this.setState({ postalCode: e.target.value, postalCodeValidated: false, loyaltyAvailable: false });
            this.validatePostal(e.target.value);
        }
    },

    handlePhoneNumberChange: function handlePhoneNumberChange(e) {
        if (e.target.value.length <= 10) {
            this.setState({ phoneNumber: e.target.value });
        }
    },

    handleLoyaltyCardNumberChange: function handleLoyaltyCardNumberChange(e) {
        var newValue = e.target.value.replace(/ /g, '');
        if (newValue.length <= 16) {
            this.setState({ loyaltyCardNumber: newValue });
        }
    },

    toggleWendyMail: function toggleWendyMail(wendyMailOptIn) {
        this.setState({ wendyMailOptIn: !wendyMailOptIn });
    },

    toggleLoyaltyCard: function toggleLoyaltyCard(hasLoyaltyCard) {
        this.setState({ hasLoyaltyCard: !hasLoyaltyCard });
    },

    toggleTermsConditions: function toggleTermsConditions(termsConditionsOptIn) {
        this.setState({ termsConditionsOptIn: !termsConditionsOptIn });
    }
});

var BackButton = createReactClass({
    displayName: 'BackButton',
    mixins: [LocalizationMixin],

    propTypes: {
        handleClick: PropTypes.func.isRequired
    },

    render: function render() {
        return React.createElement(
            'div',
            { className: 'back-button-background' },
            React.createElement(
                'div',
                { className: 'container' },
                React.createElement(
                    'div',
                    { className: 'back-wrapper',
                        onClick: this.props.handleClick,
                        onKeyDown: ADAHelpers.keyupHandler,
                        role: 'button', tabIndex: '0' },
                    React.createElement('img', { className: 'rotate-image', src: '/images/icons/ic_nav_arrow.png' }),
                    React.createElement(
                        'div',
                        { className: 'back' },
                        this.getLocalizedText("rewards_back")
                    )
                )
            )
        );
    }
});

var ChooseNextRewardWrapper = createReactClass({
    displayName: 'ChooseNextRewardWrapper',
    mixins: [LocalizationMixin],

    propTypes: {
        rewardOptions: PropTypes.array.isRequired,
        currentTotalPoints: PropTypes.number.isRequired,
        setSelectedReward: PropTypes.func.isRequired,
        selectedReward: PropTypes.object,
        cancelChooseNextReward: PropTypes.func.isRequired
    },

    render: function render() {
        return React.createElement(
            'div',
            { className: 'loyalty-sign-up col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2' },
            React.createElement(
                'div',
                { className: 'row' },
                React.createElement(PageTitle, { titleText: this.getLocalizedText('rewards_choose_your_reward') }),
                React.createElement(
                    'div',
                    { className: 'subtitle' },
                    this.getLocalizedText('rewards_choose_your_reward_subtitle')
                )
            ),
            React.createElement(ChooseNextRewardComponent, {
                lang: this.props.lang, cntry: this.props.cntry,
                rewardOptions: this.props.rewardOptions,
                currentTotalPoints: this.props.currentTotalPoints,
                setSelectedReward: this.props.setSelectedReward,
                selectedRewardId: this.props.selectedReward ? this.props.selectedReward.rewardId : -1,
                isSignUpPage: true })
        );
    }
});

var HeroImageComponent = createReactClass({
    displayName: 'HeroImageComponent',
    mixins: [LocalizationMixin],

    propTypes: {
        includedFields: PropTypes.array.isRequired
    },

    render: function render() {
        var isPhoneNumberDisplayed = _.includes(this.props.includedFields, FieldNames.PHONE);
        var isComingSoonDisplayed = _.includes(this.props.includedFields, FieldNames.COMING_SOON);

        var valueText1 = this.getLocalizedText('rewards_join_value_prop_step1');
        if (isPhoneNumberDisplayed) {
            valueText1 = this.getLocalizedText('rewards_join_value_prop_available');
        } else if (isComingSoonDisplayed) {
            valueText1 = this.getLocalizedText('rewards_join_value_prop_unavailable');
        }

        return React.createElement(
            'div',
            { className: 'step2-hero-wrapper' },
            React.createElement(
                'div',
                { className: 'flex-wrapper' },
                React.createElement('div', { className: 'diagonal-zone' }),
                React.createElement(
                    'div',
                    { className: 'hero-section-1 IntroBold' },
                    valueText1,
                    React.createElement('div', { className: 'separator' }),
                    React.createElement('img', { className: 'wendys-rewards-logo', src: '/images/common/ic_rewnew_mobile.svg' })
                ),
                React.createElement('div', { className: 'hero-section-2' }),
                isPhoneNumberDisplayed && React.createElement(
                    'div',
                    { className: 'hero-section-3 IntroSemiBold' },
                    React.createElement(
                        'div',
                        { className: 'line-1' },
                        this.getLocalizedText('rewards_join_value_prop3')
                    ),
                    React.createElement(
                        'div',
                        { className: 'line-2' },
                        this.getLocalizedText('rewards_join_value_prop4')
                    )
                )
            )
        );
    }
});

var PostalCodeInputComponent = createReactClass({
    displayName: 'PostalCodeInputComponent',
    mixins: [LocalizationMixin],

    propTypes: {
        handlePostalChange: PropTypes.func.isRequired,
        loyaltyAvailable: PropTypes.bool.isRequired,
        postalCode: PropTypes.string,
        showPostalLoading: PropTypes.bool.isRequired
    },

    render: function render() {
        return React.createElement(LoyaltyInputComponent, { fieldName: "loyalty-postal",
            currentValue: this.props.postalCode,
            onChangeHandler: this.props.handlePostalChange,
            inputIsValidated: this.props.loyaltyAvailable,
            showLoadingSpinner: this.props.showPostalLoading,
            labelText: this.getLocalizedText('rewards_join_postal_label'),
            inputPlaceholderText: this.getLocalizedText('rewards_join_postal_placeholder'),
            inputHintText: this.getLocalizedText('rewards_join_postal_hint') });
    }
});

var PhoneNumberInputComponent = createReactClass({
    displayName: 'PhoneNumberInputComponent',
    mixins: [LocalizationMixin],

    propTypes: {
        handlePhoneNumberChange: PropTypes.func.isRequired,
        phoneNumber: PropTypes.string
    },

    render: function render() {
        return React.createElement(LoyaltyInputComponent, { fieldName: "loyalty-phone",
            currentValue: this.props.phoneNumber,
            onChangeHandler: this.props.handlePhoneNumberChange,
            inputIsValidated: false,
            labelText: this.getLocalizedText('rewards_join_phone_label'),
            inputPlaceholderText: this.getLocalizedText('rewards_join_phone_placeholder'),
            inputHintText: this.getLocalizedText('rewards_join_phone_hint'),
            numericEntryOnly: true });
    }
});

var LoyaltyCardNumberToggleComponent = createReactClass({
    displayName: 'LoyaltyCardNumberToggleComponent',
    mixins: [LocalizationMixin],

    propTypes: {
        toggleLoyaltyCard: PropTypes.func.isRequired,
        hasLoyaltyCard: PropTypes.bool.isRequired
    },

    render: function render() {
        return React.createElement(
            SignUpToggleComponent,
            {
                title: this.getLocalizedText('rewards_join_loyalty_card_toggle_label'),
                handleToggleClick: this.props.toggleLoyaltyCard,
                id: 'loyalty-card',
                checked: this.props.hasLoyaltyCard,
                inputHintText: this.getLocalizedText('rewards_join_loyalty_card_toggle_hint') },
            React.createElement(
                'span',
                null,
                this.getLocalizedText('rewards_join_loyalty_card_toggle_copy')
            )
        );
    }
});

var LoyaltyCardNumberInputComponent = createReactClass({
    displayName: 'LoyaltyCardNumberInputComponent',
    mixins: [LocalizationMixin],

    propTypes: {
        handleLoyaltyCardNumberChange: PropTypes.func.isRequired,
        loyaltyCardNumber: PropTypes.string
    },

    render: function render() {
        var cardDisplayFormatted = StringHelper.formatCardNumber(this.props.loyaltyCardNumber, 4);

        return React.createElement(
            'div',
            { className: 'loyalty-card-field-wrapper' },
            React.createElement(LoyaltyInputComponent, { fieldName: "loyalty-card",
                currentValue: cardDisplayFormatted.trim(),
                onChangeHandler: this.props.handleLoyaltyCardNumberChange,
                inputIsValidated: false,
                labelText: this.getLocalizedText('rewards_join_loyalty_card_label'),
                inputPlaceholderText: this.getLocalizedText('rewards_join_loyalty_card_placeholder'),
                showLoadingSpinner: false,
                numericEntryOnly: true,
                inputHintText: this.getLocalizedText('rewards_join_loyalty_card_hint') }),
            React.createElement('img', { className: 'loyalty-card-icon', src: '/images/common/img_rewards_card_web.svg' })
        );
    }
});

var ChooseRewardComponent = createReactClass({
    displayName: 'ChooseRewardComponent',
    mixins: [LocalizationMixin],

    propTypes: {
        handleChooseRewardClick: PropTypes.func.isRequired,
        selectedReward: PropTypes.object
    },

    render: function render() {

        var contents = '';
        if (this.props.selectedReward) {
            contents = React.createElement(YourNextRewardCard, { lang: this.props.lang,
                cntry: this.props.cntry,
                nextReward: this.props.selectedReward,
                pointsNeeded: this.props.selectedReward.points,
                handleChangeToNextReward: this.props.handleChooseRewardClick,
                isSignUpPage: true });
        } else {
            contents = React.createElement(
                'div',
                { className: 'full-width card choose-reward-card' },
                React.createElement(
                    'button',
                    { 'aria-labelledby': 'rewards-join-choose-reward', id: 'rewards-choose', className: 'btn IntroBold',
                        onClick: this.props.handleChooseRewardClick },
                    this.getLocalizedText("rewards_choose").toUpperCase()
                )
            );
        }

        return React.createElement(
            'div',
            { className: 'field' },
            React.createElement(
                'label',
                { id: 'rewards-join-choose-reward',
                    className: 'IntroBold full-width' },
                this.getLocalizedText('rewards_join_choose_reward')
            ),
            contents,
            React.createElement(
                'div',
                { id: 'rewards-join-choose-reward-hint',
                    className: 'copy' },
                this.getLocalizedText('rewards_join_choose_reward_hint')
            )
        );
    }
});

var ComingSoonComponent = createReactClass({
    displayName: 'ComingSoonComponent',
    mixins: [LocalizationMixin],

    render: function render() {
        return React.createElement(
            'div',
            { className: 'field' },
            React.createElement(
                'label',
                { id: 'coming-soon', className: 'IntroBold full-width' },
                this.getLocalizedText('rewards_join_coming_soon_title')
            ),
            React.createElement(
                'div',
                { id: 'rewards-join-coming-soon-body', className: 'copy large-copy tall-lines' },
                this.getLocalizedText('rewards_join_coming_soon_body')
            )
        );
    }
});

var SignUpToggleComponent = function (_React$Component) {
    _inherits(SignUpToggleComponent, _React$Component);

    function SignUpToggleComponent() {
        _classCallCheck(this, SignUpToggleComponent);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    SignUpToggleComponent.prototype.render = function render() {
        var _this3 = this;

        return React.createElement(
            'div',
            { id: this.props.id + "-field", className: 'field' },
            !!this.props.title && React.createElement(
                'label',
                { className: 'IntroBold full-width' },
                this.props.title
            ),
            React.createElement(
                'label',
                { className: 'checkbox-inline' },
                React.createElement('input', { type: 'checkbox', id: this.props.id,
                    onChange: function onChange() {
                        return _this3.props.handleToggleClick(_this3.props.checked);
                    },
                    checked: this.props.checked }),
                React.createElement(
                    'div',
                    { className: 'copy medium-copy tall-lines' },
                    this.props.children
                ),
                this.props.inputHintText && React.createElement(
                    'div',
                    { id: "field-description-" + this.props.id + "-hint",
                        className: 'copy field-hint' },
                    this.props.inputHintText
                )
            )
        );
    };

    return SignUpToggleComponent;
}(React.Component);

SignUpToggleComponent.propTypes = {
    handleToggleClick: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    inputHintText: PropTypes.string.isRequired,
    title: PropTypes.string
};


var ToggleWendyMailComponent = createReactClass({
    displayName: 'ToggleWendyMailComponent',
    mixins: [LocalizationMixin],

    propTypes: {
        toggleWendyMail: PropTypes.func.isRequired,
        wendyMailOptIn: PropTypes.bool.isRequired
    },

    render: function render() {
        var Config = require('../../../lib/config').urls;

        return React.createElement(
            SignUpToggleComponent,
            {
                handleToggleClick: this.props.toggleWendyMail,
                id: 'wendymail',
                checked: this.props.wendyMailOptIn
            },
            React.createElement(
                'span',
                null,
                this.getLocalizedText('rewards_join_wendymail_body'),
                ' ',
                this.getLocalizedText('email_terms_text1'),
                React.createElement(
                    'a',
                    { href: Config.terms[this.props.lang + '_' + this.props.cntry], target: '_blank' },
                    ' ',
                    this.getLocalizedText("common_login_terms_of")
                ),
                ' ',
                this.getLocalizedText("common_login_and"),
                React.createElement(
                    'a',
                    { href: Config.privacy[this.props.lang + '_' + this.props.cntry], target: '_blank' },
                    ' ',
                    this.getLocalizedText("common_login_privacy_policy")
                ),
                '.'
            )
        );
    }
});

var TermsAndConditionsComponent = createReactClass({
    displayName: 'TermsAndConditionsComponent',
    mixins: [LocalizationMixin],

    propTypes: {
        toggleTermsConditions: PropTypes.func.isRequired,
        termsConditionsOptIn: PropTypes.bool.isRequired
    },

    render: function render() {
        var Config = require('../../../lib/config').urls;

        return React.createElement(
            SignUpToggleComponent,
            {
                handleToggleClick: this.props.toggleTermsConditions,
                id: 'terms',
                checked: this.props.termsConditionsOptIn },
            React.createElement(
                'span',
                null,
                this.getLocalizedText('rewards_terms_and_conditions_preface')
            ),
            React.createElement(
                'a',
                { href: Config.rewardsTerms[this.props.lang + '_' + this.props.cntry],
                    target: '_blank' },
                ' ',
                this.getLocalizedText("rewards_terms_and_conditions")
            )
        );
    }
});

var SkipLoyaltyComponent = createReactClass({
    displayName: 'SkipLoyaltyComponent',
    mixins: [LocalizationMixin],

    propTypes: {
        handleSkipRewardsClick: PropTypes.func.isRequired
    },

    render: function render() {
        return React.createElement(
            'div',
            { className: 'skip-loyalty-button', onClick: this.props.handleSkipRewardsClick, onKeyDown: ADAHelpers.keyupHandler, role: 'button', tabIndex: '0' },
            React.createElement(
                'a',
                { id: 'skip-loyalty-button', className: 'IntroRegularCaps skip-loyalty-button full-width' },
                this.getLocalizedText('rewards_skip_button')
            )
        );
    }
});

var NotNowLoyaltyButton = createReactClass({
    displayName: 'NotNowLoyaltyButton',
    mixins: [LocalizationMixin],

    propTypes: {
        handleNotNowClick: PropTypes.func.isRequired
    },

    render: function render() {
        return React.createElement(
            'div',
            { className: 'skip-loyalty-button', onClick: this.props.handleNotNowClick, onKeyDown: ADAHelpers.keyupHandler, role: 'button', tabIndex: '0' },
            React.createElement(
                'a',
                { id: 'skip-loyalty-button', className: 'IntroRegularCaps skip-loyalty-button full-width' },
                this.getLocalizedText('rewards_not_now')
            )
        );
    }
});

var LoyaltyCTAButton = createReactClass({
    displayName: 'LoyaltyCTAButton',
    mixins: [LocalizationMixin],

    propTypes: {
        buttonText: PropTypes.string.isRequired,
        clickHandler: PropTypes.func.isRequired,
        enabled: PropTypes.bool.isRequired
    },

    render: function render() {
        return React.createElement(
            'button',
            { id: 'loyalty-cta-button', disabled: !this.props.enabled, className: 'IntroBold loyalty-cta-button full-width btn btn-primary',
                onClick: this.props.clickHandler },
            this.props.buttonText
        );
    }
});

var LoyaltyInputComponent = createReactClass({
    displayName: 'LoyaltyInputComponent',
    mixins: [LocalizationMixin],

    propTypes: {
        fieldName: PropTypes.string.isRequired,
        labelText: PropTypes.string,
        currentValue: PropTypes.string,
        inputPlaceholderText: PropTypes.string,
        inputHintText: PropTypes.string,
        onChangeHandler: PropTypes.func.isRequired,
        inputIsValidated: PropTypes.bool.isRequired,
        showLoadingSpinner: PropTypes.bool.isRequired,
        numericEntryOnly: PropTypes.bool.isRequired
    },

    onKeyPress: function onKeyPress(e) {
        if (this.props.numericEntryOnly && (e.charCode < 48 || e.charCode > 57)) {
            e.preventDefault();
        }
    },

    render: function render() {
        var fieldId = "field-description-" + this.props.fieldName;
        var inputId = "input-" + this.props.fieldName;

        return React.createElement(
            'div',
            { className: 'field' },
            React.createElement(
                'label',
                { id: fieldId, className: 'IntroBold full-width',
                    htmlFor: inputId },
                React.createElement(
                    'span',
                    null,
                    this.props.labelText
                )
            ),
            React.createElement(
                'div',
                { className: 'card' },
                React.createElement(
                    'div',
                    { className: 'input-group' },
                    React.createElement('input', { type: 'text', id: inputId, className: 'form-control', 'aria-describedby': fieldId,
                        placeholder: this.props.inputPlaceholderText, onChange: this.props.onChangeHandler, onKeyPress: this.onKeyPress,
                        value: this.props.currentValue }),
                    this.props.inputIsValidated ? React.createElement('img', { id: this.props.fieldName + "-feedback", className: 'feedback', src: '/images/icons/ic_green_checkmark.png' }) : '',
                    !this.props.inputIsValidated && this.props.showLoadingSpinner ? React.createElement('img', { id: this.props.fieldName + "-feedback", className: 'feedback', src: '/images/common/ic_inline_brown.gif' }) : '',
                    React.createElement(
                        'div',
                        { id: fieldId + "-hint", className: 'copy field-hint' },
                        this.props.inputHintText
                    )
                )
            )
        );
    }
});

module.exports = LoginLoyaltyStepTwo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/loginComponents/loyalty/loyaltySignUp.js
// module id = 736
// module chunks = 0